import React, { type CSSProperties, type PropsWithChildren } from 'react'
import { omit } from 'lodash-es'

import Badge from 'antd/lib/badge'
import 'antd/lib/badge/style/css'

import './BadgeComponent.scss'

type BadgeComponentProps = PropsWithChildren<{
  color?: string
  style?: CSSProperties
  count?: string | number
}>

const BadgeComponent = (props: BadgeComponentProps) => {
  const { style, color } = props

  const newStyle: React.CSSProperties = {
    ...style,
  }

  if (color) {
    // @ts-expect-error — no idea why this is complaining
    newStyle.backgroundColor = color
    // @ts-expect-error — no idea why this is complaining
    newStyle.boxShadow = `0 0 0 1px ${color}`
  }

  // Antd workaround. They show a dot if status or color is truthy.
  // @see https://github.com/ant-design/ant-design/blob/3.26.20/components/badge/index.tsx#L106
  const badgeProps = omit(props, ['color'])

  return (
    <div className="badge-component antd-component">
      <Badge {...badgeProps} style={newStyle} />
    </div>
  )
}

export { BadgeComponent }
